import { AuthContext } from 'contexts/AuthContext';
import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import SelectClass from './components/SelectClass';
import StudentJobOverviewTable from './components/StudentOverviewTable';
import jobServices from 'ApiService/Student/jobServices';

const Index = () => {
  const [classData, setClassData] = useState({
    courseId: '',
    batchId: '',
  });
  const [loadingCourses, setLoadingCourses] = useState(true);
  const [courses, setCourses] = useState([]);
  const { state } = useContext(AuthContext);
  const [selectedStandard, setSelectedStandard] = useState(null);

  const [loadingStudentData, setLoadingStudentData] = useState(false);
  const selectedBranch = state?.selectedBranch || '';

  const fetchAllData = async () => {
    setLoadingStudentData(true);
    try {
      const requestData = {};
      if (classData.courseId) {
        requestData.courseId = classData.courseId;
      }
      if (classData.batchId) {
        requestData.batchId = classData.batchId;
      }
      // if (selectedBranch) {
      //   requestData.branchId = selectedBranch;
      // }
      const response = await jobServices.studentGetPlacementOverview();

      if (response.data.success) {
        const data = response.data.data;
        setSelectedStandard(data || []);
        setLoadingStudentData(false);
        if (response.data.data.length === 0) {
          toast.error('No students found ');
        }
      } else {
        setSelectedStandard([]);
        toast.error(response?.data?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to fetch data');
    } finally {
      setLoadingStudentData(false);
    }
  };

  useEffect(() => {
    // if (classData.batchId) {
    fetchAllData();
    // }
  }, []);

  return (
    <div className="mt-3 flex h-full w-full flex-col gap-[20px] rounded-[20px]">
      {/* <div className="h-full w-full rounded-[20px]">
        <SelectClass
          setClassData={setClassData}
          classData={classData}
          courses={courses}
          loadingCourses={loadingCourses}
        />
      </div> */}
      {/* <div className="h-full w-full rounded-t-2xl">
        {selectedStandard && ( */}
      <StudentJobOverviewTable
        data={selectedStandard}
        isLoading={loadingStudentData}
      />
      {/* )} */}
      {/* </div> */}
    </div>
  );
};

export default Index;
